module.exports = __webpack_public_path__ + "assets/img/gar1-1.f280fc2f.jpg";